module.exports = __webpack_public_path__ + "static/assets/3d0c90aed47604658ef997be8e55f59c.png";